import * as $ from "jquery";
import * as ko from "knockout";

export namespace ReadOnlyDisabled {
    ko.bindingHandlers.readonly = {
        update: (element: HTMLElement, valueAccessor: () => boolean | KnockoutObservable<boolean>): void => {
            const value = ko.utils.unwrapObservable(valueAccessor());

            if (value) {
                $(element).attr("readonly", "readonly");
            } else {
                $(element).removeAttr("readonly");
            }
        }
    };
}